<template v-slot:top>
  <v-card>
    <v-card-title class="headline center">Visualizar Tokens</v-card-title>

    <v-container>
      <v-slide-group show-arrows>
        <v-slide-item v-for="n in lotes" :key="n" v-slot="{ active, toggle }">
          <v-btn
            class="mx-2"
            :input-value="active"
            active-class="success white--text"
            depressed
            @click="toggle"
            v-on:click="setLote(n)"
          >
            Lote {{ n }}
          </v-btn>
        </v-slide-item>
      </v-slide-group>
    </v-container>

    <v-expansion-panels v-if="seletedLote">
      <v-expansion-panel v-for="i in documents" :key="i">
        <v-expansion-panel-header @click="setDocuments(i)">
          {{ i }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card class="mb-2">
            <v-card-title>
              Filtros
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col>
                  <v-btn-toggle
                    v-model="viewTokensFilter"
                    tile
                    color="deep-purple accent-3"
                    group
                  >
                    <v-btn value="all">
                      Ver Todos
                    </v-btn>

                    <v-btn value="certificate">
                      Certificados
                    </v-btn>

                    <v-btn value="emited">
                      Emitidos
                    </v-btn>

                    <v-btn value="free">
                      A emitir
                    </v-btn>
                  </v-btn-toggle>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="viewTokenStart"
                    label="Visualizar início em (inicia em 0)"
                    required
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    v-model="viewTokenEnd"
                    label="Visualizar até"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="(viewTokenEnd - viewTokenStart) > 300">
                <v-col class="red--text">O intervalo máximo entre início e fim recomendado é de 300 unidades. Caso contrário a aplicação perderá performance.</v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="teal darken-3"
                text
                @click="filter"
              >
                Clique para Filtrar
              </v-btn>
            </v-card-actions>
          </v-card>
          <ul id="tokens2">
            <li v-for="token in filteredTokens" :key="token.id">
              <v-btn
                v-bind:color="
                  token.certificate_id
                    ? 'success'
                    : token.user_id
                    ? 'yellow'
                    : 'gray'
                "
                @click="details(token.id)"
              >
                {{ token.name }}
              </v-btn>
            </li>
          </ul>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-dialog v-model="detail" max-width="940px">
      <v-card id="tokensdetails">
        <v-card-title class="headline center">
          <v-row>
            <v-col cols="3" sm="3" md="3">
              <p >Token</p>
              <p style="color : gray">{{ tokenEspecific[0] ? tokenEspecific[0].name : "-" }}</p>
            </v-col>
            <v-col cols="3" sm="3" md="3">
              <p>Matricula</p>

              <p style="color : gray">
                {{
                  tokenEspecific[1] ? tokenEspecific[1].name_registration : "-"
                }}
              </p>
            </v-col>
            <v-col cols="3" sm="3" md="3">
              <p>Lote</p>

              <p style="color : gray">{{ tokenEspecific[0] ? tokenEspecific[0].lote : "-" }}</p>
            </v-col>
            <v-col cols="3" sm="3" md="3">
              <p>Ativo</p>
              <p style="color : gray">
                {{ tokenEspecific[0] ? tokenEspecific[0].name_token : "-" }}
              </p>
            </v-col>
          </v-row>
        </v-card-title>

        <v-container>
          <v-row v-if="tokenEspecific[1] && tokenEspecific[1].name">
            <v-col cols="12">
              Propriedade de {{ tokenEspecific[1].name }}
            </v-col>
          </v-row>
          <v-row v-if="tokenEspecific[1] && tokenEspecific[1].created_at">
            <v-col cols="12">
              Data de emissão certificado:
              {{ formatDate(tokenEspecific[1].created_at) }}
            </v-col>
          </v-row>
          <v-row v-if="tokenEspecific[1] && tokenEspecific[0].blockchain_id">
            <v-col cols="12">
              Código do token na blockchain: {{ tokenEspecific[0].blockchain_id }}
            </v-col>
          </v-row>
          <v-row v-if="tokenEspecific[1] && tokenEspecific[1].certificate_blockchain_id">
            <v-col cols="12">
              Código do certificado na blockchain: {{ tokenEspecific[1].certificate_blockchain_id }}
            </v-col>
          </v-row>
          <v-row v-if="tokenEspecific[1] && tokenEspecific[1].certificate_blockchain_id">
            <v-col cols="12">
              Certificado na blockchain: {{ tokenEspecific[1].certificate_blockchain_id }}
            </v-col>
          </v-row>
        </v-container>

        <v-card-actions v-if="isLoadingGenerate">
          <v-spacer></v-spacer>
          <v-btn color="#0dc4b8" text @click="closeDetailsModal">Fechar</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container v-if="!isLoadingGenerate">
      <div style="min-height: 10px">
        <v-progress-linear
          v-model="value"
          :active="show"
          :indeterminate="query"
          :query="true"
        ></v-progress-linear>
      </div>
    </v-container>
  </v-card>
</template>


<script>
// import { mapMutations } from "vuex";
// import ClientsService from "../../services/clients.service";
import Api from "../../services/api.service";
import moment from "moment";

export default {
  name: "VisualModal",
  props: {
    selectedIndex: {
      type: Number,
      required: false,
      default: -1,
    },
    selectedData: Object,
  },
  data: () => ({
    tokens: [],
    tokensGeral: [],
    tokensLote: [],
    lotes: [],
    fixedValue: false,
    typeValue: false,
    variableValue: false,
    selectedItem: {},
    isLoadingGenerate: true,
    value: 10,
    model: null,
    show: true,
    query: false,
    numberLote: 0,
    detail: false,
    documentsGeral: [],
    documents: [],
    seletedLote: false,
    tokenEspecific: [],
    viewTokensFilter: 'all',
    viewTokenStart: 0,
    viewTokenEnd: 300,
    filteredTokens: []
  }),
  methods: {
    typeValueMounted(value) {
      this.selectedItem.valueType = value;

      if (value === 1) {
        this.fixedValue = true;
        this.variableValue = false;
      } else {
        this.fixedValue = false;
        this.variableValue = true;
      }
    },
    formatDate(value) {
      return moment(value).format("DD/MM/YYYY");
    },
    setLote(n) {
      this.tokensLote = [];
      this.documents = [];
      this.numberLote = n;
      this.seletedLote = true;
      this.tokens = [];
      this.tokensGeral.map((item) => {
        if (item.lote == n) {
          this.documents.push(item.name_registration);
          this.tokensLote.push(item);
        }
      });
    //  this.documents.push("Sem documentação vinculada");

      this.documents = this.documents.filter(
        (este, i) => this.documents.indexOf(este) === i
      );

      this.documents = this.documents.filter(Boolean);
    },

    resetFilters() {
        this.viewTokensFilter = 'all';
        this.viewTokenStart = 0;
        this.viewTokenEnd = 300;
    },

    filter() {
      this.filteredTokens = this.tokens.slice(this.viewTokenStart, Math.min(this.viewTokenEnd, this.tokens.length-1));
      this.filteredTokens = this.filteredTokens.filter((el) => {
        switch(this.viewTokensFilter) {
          case 'all':
            return true;
          case 'certificate':
            if(el.certificate_id)
              return true;
            return false;
          case 'emited':
            if(el.user_id)
              return true;
            return false;
          case 'free':
            if(el.certificate_id || el.user_id)
              return false;
            return true;
        }
      })
    },

    setDocuments(e) {
      this.tokens = [];

      this.resetFilters();

      this.tokensLote.map((item) => {
        if (item.name_registration == e) this.tokens.push(item);
        // if (e == "Sem documentação vinculada" && !item.name_registration)
        //   this.tokens.push(item);
      });

      this.filteredTokens = this.tokens.slice(this.viewTokenStart, Math.min(this.viewTokenEnd, this.tokens.length-1));
    },
    details(n) {
      this.detail = true;
      Api.get(`token/${n}`)
        .then((res) => {
          this.tokenEspecific = res.data.token.concat(res.data.complement);
        })
        .catch(() => {
          this.showSnackbar({
            text: "Ops!, Houve um erro ao carregar as categorias, tente novamente mais tarde.",
            color: "error",
          });
        });
    },
    closeDetailsModal() {
      this.detail = false;
    },

    loadTokensGenerate() {
      Api.get(`generation-tokens/${this.selectedIndex}`)
        .then((res) => {
          res.data.lotes.map((item) => {
            this.lotes.push(item.lote);
          });

          this.documentsGeral = res.data.documents;
          // this.documentsGeral.push({
          //   name_registration: "Sem documentação vinculada",
          // });

          this.tokensGeral = res.data.tokens.concat(res.data.tokensDoc);
          this.tokens = [];
        })
        .catch(() => {
          this.showSnackbar({
            text: "Ops!, Houve um erro ao carregar as categorias, tente novamente mais tarde.",
            color: "error",
          });
        });
    },
  },

  mounted() {
    if (this.selectedIndex !== -1) {
      // this.fakeTokensGrid();
      this.loadTokensGenerate();
      setTimeout(() => {
        var type = this.selectedData.type_value === "Valor Fixo" ? 1 : 2;

        this.typeValueMounted(type);
        this.typeValue = type;
        this.selectedItem.valueType = this.selectedData.type_value;

        this.selectedItem.nameToken = this.selectedData.name_token;
        this.selectedItem.description = this.selectedData.description;
        this.selectedItem.category = this.selectedData.category;
        this.selectedItem.amountToken = this.selectedData.amount_token;
        this.selectedItem.cryptoactive = this.selectedData.cryptoactive;
        this.selectedItem.certificate = this.selectedData.certificate;
        this.selectedItem.deadlineToken = this.selectedData.deadline_token;
        setTimeout(() => {
          if (type === 1) {
            this.fixedValue = true;
            this.variableValue = false;
          } else {
            this.fixedValue = false;
            this.variableValue = true;
          }

          this.selectedItem.minValueToken = this.selectedData.min_value_token;
          this.selectedItem.totalValueToken =
            this.selectedData.total_value_token;
          this.selectedItem.singleValue = this.selectedData.single_value;
        }, 100);
      }, 10);
    }
  },
};
</script>
<style scoped>
#tokensdetails p {
  margin: -10px 2px;
  font-size: 1rem;
  text-align: center;
}
</style>
